import { useMetaTags } from 'react-metatags-hook';

const MetaTagsComponent = ({ lang = 'ru' }) => {
  const ruMeta = {
    title: 'C4U | IT Courses for Women with German State Funding',
    description: 'Professional IT training for women in AI, Tech, and Non-tech tracks. Funded by Bildungsgutschein, Aufstiegs-BAföG, and other German programs.',
    keywords: 'IT courses for women, German funding, Bildungsgutschein, women in tech, AI training, software engineering, UI/UX design, career change for women',
    ogTitle: 'C4U | IT Courses for Women with German State Funding',
    ogDescription: 'Professional IT training for women in AI, Tech, and Non-tech tracks. Funded by Bildungsgutschein, Aufstiegs-BAföG, and other German programs.',
    ogLocale: 'en_US',
    url: 'https://c4u-uk.com/'
  };

  const deMeta = {
    title: 'C4U | IT-Kurse für Frauen mit deutscher Staatsförderung',
    description: 'Professionelle IT-Ausbildung für Frauen in KI, Tech und Non-Tech Bereichen. Finanziert durch Bildungsgutschein, Aufstiegs-BAföG und andere deutsche Programme.',
    keywords: 'IT-Kurse für Frauen, deutsche Förderung, Bildungsgutschein, Frauen in der Technik, KI-Training, Software Engineering, UI/UX Design, Karrierewechsel für Frauen',
    ogTitle: 'C4U | IT-Kurse für Frauen mit deutscher Staatsförderung',
    ogDescription: 'Professionelle IT-Ausbildung für Frauen in KI, Tech und Non-Tech Bereichen. Finanziert durch Bildungsgutschein, Aufstiegs-BAföG und andere deutsche Programme.',
    ogLocale: 'de_DE',
    url: 'https://c4u-uk.com/de'
  };

  const enMeta = {
    title: 'Thank You | C4U IT Courses for Women',
    description: 'Thank you for your interest in our IT courses. We will contact you soon to discuss your next steps in our training program.',
    keywords: 'thank you, IT courses application, women in tech, course enrollment',
    ogTitle: 'Thank You | C4U IT Courses for Women',
    ogDescription: 'Thank you for your interest in our IT courses. We will contact you soon to discuss your next steps in our training program.',
    ogLocale: 'en_US',
    url: 'https://c4u-uk.com/thank-you'
  };

  const signInMeta = {
    title: 'Sign In | C4U IT Courses for Women',
    description: 'Sign in to access our IT courses for women. Choose your track in AI, Tech, or Non-tech and start your career transformation.',
    keywords: 'sign in, IT courses, women in tech, course enrollment, career change',
    ogTitle: 'Sign In | C4U IT Courses for Women',
    ogDescription: 'Sign in to access our IT courses for women. Choose your track in AI, Tech, or Non-tech and start your career transformation.',
    ogLocale: 'en_US',
    url: 'https://c4u-uk.com/sign-in'
  };

  const meta = lang === 'de' ? deMeta : lang === 'en' ? enMeta : lang === 'signin' ? signInMeta : ruMeta;

  useMetaTags(
    {
      title: meta.title,
      description: meta.description,
      lang: lang,
      metas: [
        { name: 'keywords', content: meta.keywords },
        { name: 'robots', content: 'noodp' }
      ],
      links: [
        { rel: 'alternate', hreflang: 'en', href: 'https://c4u-uk.com/' },
        { rel: 'alternate', hreflang: 'de', href: 'https://c4u-uk.com/de' },
        { rel: 'alternate', hreflang: 'x-default', href: 'https://c4u-uk.com/' }
      ],
      openGraph: {
        type: 'website',
        url: meta.url,
        title: meta.ogTitle,
        description: meta.ogDescription,
        locale: meta.ogLocale,
        image: '%PUBLIC_URL%/presentation.webp',
        'image:width': '1200',
        'image:height': '630'
      },
      twitter: {
        card: 'summary',
        url: meta.url,
        title: meta.ogTitle,
        description: meta.ogDescription,
        image: '%PUBLIC_URL%/presentation.webp'
      }
    },
    [lang]
  );

  return null;
};

export { MetaTagsComponent }; 